import type { IGraphColors } from '@/version-types';

/**
 * 拍平复杂图形颜色
 *
 * @param colors - 颜色列表
 */
export function flatGraphColors(colors: IGraphColors[]) {
    const res: string[] = [];
    colors?.forEach((item) => {
        const { color, values } = item;
        values.forEach((val) => {
            res[val] = color;
        });
    });
    return res;
}

/**
 * 打包复杂图形颜色
 *
 * @param colors - 颜色列表
 */
export function packGraphColors(colors: string[]) {
    const res: IGraphColors[] = [];
    const map: { [key: string]: number[] } = {};
    colors?.forEach((color, index) => {
        map[color] = map[color] || [];
        map[color].push(index);
    });
    Object.keys(map).forEach((color) => {
        res.push({
            color,
            values: map[color],
        });
    });
    return res;
}
